import React from 'react';
import { connect } from 'react-redux'
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale'
import {addAnnouncement} from 'containers/pages/Announcement/redux/actions/addAnnouncement'
import {updateAnnouncement} from 'containers/pages/Announcement/redux/actions/updateAnnouncement'
import {fetchAnnouncementList} from 'containers/pages/Announcement/redux/actions/getAnnouncementList'
import {setCurrentTabState} from 'containers/pages/Announcement/redux/actions/setCurrentTabState'
const mapStateToProps = (state) => ({
  currentTabState: state.announcementList.currentTabState
})

const mapDispatchToProps = (dispatch) => {
  return {
    addAnnouncement: (schoolId, announcementInfo, cb) => dispatch(addAnnouncement(schoolId, announcementInfo, cb)),
    updateAnnouncement: (announcementId, announcementInfo, currentTabState,callback) => dispatch(updateAnnouncement(announcementId, announcementInfo, currentTabState,callback)),
    fetchAnnouncementList: (announcementInfo, currentTabState) => dispatch(fetchAnnouncementList(announcementInfo, currentTabState)),
    setCurrentTabState: (currentTabState) => dispatch(setCurrentTabState(currentTabState))
  }
}

class ModalBody extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      disabledBtn: false
    }
  }

  onSubmit(data, state){
    const schoolId = localStorage.getItem('schoolId')
    let {dismiss, dispatch, currentTabState, setCurrentTabState} = this.props;
    if(!this.formData){
      this.setState({disabledBtn: false})
      return alert.warning(__('All Fields with * Must Be Filled', locale))
    }

    let {title, content, class_id_list} = this.formData

    if(!title || !content || class_id_list.length <= 0){
      this.setState({disabledBtn: false})
      return alert.warning(__('All Fields with * Must Be Filled', locale))
    }

    if(data){
      let newData = {...this.formData, send_to: 'all', state}
      if(newData.class_id_list[0].value == 0){
        newData = {...newData, class_id_list: 'all'}
      }

      this.props.updateAnnouncement(data.id, newData, currentTabState, () => {
        let tabIndex;
        if(currentTabState.tabName === 'published') {
          tabIndex = 1;
        }else if (currentTabState.tabName === 'draft') {
          tabIndex = 2;
        }else {
          tabIndex = 0;
        }
        setCurrentTabState({tabName:currentTabState.tabName, tabIndex});
        this.props.proceed()
      })
    } else {
      let newData = {...this.formData, send_to: 'all', state}
      if(newData.class_id_list[0] == 0){
        newData = {...newData, class_id_list: 'all'}
      }
      this.props.addAnnouncement(schoolId, newData, () => {
        let tabIndex;
        if(state === 'published') {
          if(currentTabState.tabName === 'published' || currentTabState.tabName === 'draft') {
            tabIndex = 1;
            this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'published'})
          }else {
            tabIndex = 0;
            this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1})
          }
        }else {
          if(currentTabState.tabName === 'published' || currentTabState.tabName === 'draft') {
            tabIndex = 2;
            this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'draft'})
          }else {
            tabIndex = 0;
            this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1})
          }
        }
        setCurrentTabState({tabName:currentTabState.tabName, tabIndex});
        this.props.proceed()
      })
    }
  }

	render() {
    let {show, proceed, dismiss, cancel, data, allowEdit, selectedIndex} = this.props;

		return (
			<Modal
				className='announcement-modal'
				hasHeader={true}
				hasFooter={allowEdit}

				headerTitle={__("Announcement Content", locale)}
				headerIcon="fa icon-megaphone"

        fixedWidth={550}
        contentHeight={450}
        onCloseModalClick={dismiss}

        footerType="grey"
        isShowingModal={show}
        footerButtons={allowEdit && [
          {
            title: __('Publish', locale),
            className: 'btn btn-primary pull-right',
            onClick: () => {
              this.setState({disabledBtn: true})
              let state = 'published'
              this.onSubmit(data, state)
            }
          },
          {
            title: __('Save', locale),
            className: 'btn btn-default pull-right',
            onClick: () => {
              this.setState({disabledBtn: true})
              let state = 'draft'
              this.onSubmit(data, state)
            },
            isDisabled: ()=>{
              return this.state.disabledBtn
            }
          }
        ]}>
        <ModalContent
          {...this.props}
          onFormChange={(stateFromModalContent) => { this.formData = stateFromModalContent; }} />
			</Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/Announcement/ModalBody.js